<template>
    <tg-layout>
        <template slot="header">
            <tg-search-tool @on-submit="handleSearch">
                <tg-date-picker v-model="searchData.openDate"></tg-date-picker>
            </tg-search-tool>
        </template>
        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            showPagination
        >
            <template slot="game_name" slot-scope="scope">
                <span>[{{ scope.row["competition"] }}]</span><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["home"] }}</span
                ><br />
                <span
                    ><i class="tg-icon tg-icon-grayball"></i
                    >{{ scope.row["away"] }}</span
                ><br />
            </template>

            <template slot="first_goal_time" slot-scope="scope">
                <template v-if="scope.row[scope.column.name]">
                    <span>{{scope.row[scope.column.name] == 0 ? $t('enum.marketType[0].no_goal') : $t('enum.marketType[0].goal_time', {min: scope.row[scope.column.name]})}}</span>
                </template>
            </template>
        </tg-table>
    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDatePicker from "@/components/datePicker/TgDatePicker";
import TgTable from "@/components/table/TgTable";

import apis from "@/apis";

const api = apis.game.result;

export default {
    components: {
        TgLayout,
        TgSearchTool,
        TgDatePicker,
        TgTable,
    },
    data() {
        return {
            columns: [],
            proxy: api.getData,
            searchData: {
                openDate: "",
            },
        };
    },
    created() {
        api.getColumns().then((response) => {
            this.columns = response.data;
            this.$nextTick(() => {
                this.$refs.table.init(this.searchData);
            });
        });
    },
    methods: {
        handleSearch() {
            this.$refs.table.search(this.searchData);
        },
    },
};
</script>